export const isDev = import.meta.env.MODE === 'development'
export const isProd = import.meta.env.MODE === 'production'

export const API_ENV = import.meta.env.VITE_API_ENV
export const isBetaAPI = API_ENV === 'BETA'
export const isProdAPI = API_ENV === 'PROD'

export const isDevWithProdAPI = isDev && isProdAPI
